import { addLocaleData, defineMessages } from 'react-intl';
import * as de from 'react-intl/locale-data/de';
import * as en from 'react-intl/locale-data/en';
import * as fi from 'react-intl/locale-data/fi';
import * as fr from 'react-intl/locale-data/fr';
import * as no from 'react-intl/locale-data/no';
import * as sv from 'react-intl/locale-data/sv';

/*
  TODO: thing about loading a locale data file in a runtime without a module system (use global variable ReactIntl)
  https://github.com/yahoo/react-intl/wiki#loading-locale-data
*/

addLocaleData([...en, ...sv, ...no, ...de, ...fr, ...fi]);

const messages = defineMessages({
  choose_language_label: {
    id: 'choose_language_label',
    defaultMessage: 'Choose your language'
  },
  // Bag
  empty_bag_info: {
    id: 'empty_bag_info',
    defaultMessage: 'You have no items in your bag'
  },
  empty_bag_button_label: {
    id: 'empty_bag_button_label',
    defaultMessage: 'Continue Shopping'
  },
  // Minicart
  minicart_label: {
    id: 'minicart_label',
    defaultMessage: 'Bag'
  },
  // Error messages
  expire_error_message: {
    id: 'expire_error_message',
    defaultMessage: 'Sorry, your session has expired'
  },
  ingrid_not_available_error: {
    id: 'ingrid_not_available_error',
    defaultMessage: 'We’re sorry, but our shipping service is not available in your area'
  },
  error_header: {
    id: 'error_header',
    defaultMessage: 'Oops, something went wrong'
  },
  default_error_message: {
    id: 'default_error_message',
    defaultMessage: 'Try to refresh this page or feel free to contact us if the problem persists'
  },
  product_not_found: {
    id: 'product_not_found',
    defaultMessage: 'Sorry, product item not found'
  },
  voucher_not_found: {
    id: 'voucher_not_found',
    defaultMessage: 'This code did not match any active gift card or discount. Was it entered correctly?'
  },
  unavailable_items: {
    id: 'unavailable_items',
    defaultMessage: 'Some items were not available and have been removed from the cart'
  },
  unavailable_items_info: {
    id: 'unavailable_items_info',
    defaultMessage: 'Removed {quantity} × {product}'
  },
  address_shipping_note: {
    id: 'address_shipping_note',
    defaultMessage: 'Your order will automatically be shipped to the delivery address registered to your PayPal account'
  },
  country_mismatch: {
    id: 'country_mismatch',
    defaultMessage: 'Please checkout with the same country as in Paypal'
  },
  paypal_note: {
    id: 'paypal_note',
    defaultMessage: 'Note: To avoid unnecessary checkout failure please use the same country address when proceed to you PayPal account'
  },
  payment_method_failed: {
    id: 'payment_method_failed',
    defaultMessage: 'We’re sorry.'
  },
  selection_not_found: {
    id: 'selection_not_found',
    defaultMessage: 'Something went wrong'
  },
  // Fields error messages
  required_valid_error: {
    id: 'required_valid_error',
    defaultMessage: 'This field is required'
  },
  passwords_match_valid_error: {
    id: 'passwords_match_valid_error',
    defaultMessage: 'Passwords must match'
  },
  email_valid_error: {
    id: 'email_valid_error',
    defaultMessage: 'Invalid e-mail address'
  },
  personnummer_valid_error: {
    id: 'personnummer_valid_error',
    defaultMessage: 'Wrong format (ÅÅMMDDXXXX)',
  },
  phone_valid_error: {
    id: 'phone_valid_error',
    defaultMessage: 'Invalid phone number'
  },
  min_length_error: {
    id: 'min_length_error',
    defaultMessage: 'Must be {min} characters or more'
  },
  max_length_error: {
    id: 'max_length_error',
    defaultMessage: 'Must be {max} characters or less'
  },
  alphanumeric_valid_error: {
    id: 'alphanumeric_valid_error',
    defaultMessage: 'This field accepts only letters and special characters'
  },
  // Steps
  step_edit: {
    id: 'step_edit',
    defaultMessage: 'Edit'
  },
  shipping_step_button_title: {
    id: 'shipping_step_button_title',
    defaultMessage: 'Continue to payment method'
  },
  shipwallet_step_button_title: {
    id: 'shipwallet_step_button_title',
    defaultMessage: 'Continue to payment method'
  },
  shop_working_hours_info: {
    id: 'shop_working_hours_info',
    defaultMessage: 'Orders are sent between 11:00 and 12:00',
  },
  address_step_button_title: {
    id: 'address_step_button_title',
    defaultMessage: 'Continue to shipping method'
  },
  shipping_step_title: {
    id: 'shipping_step_title',
    defaultMessage: 'Delivery options'
  },
  shipwallet_step_title: {
    id: 'shipwallet_step_title',
    defaultMessage: 'Shipping method'
  },
  shipwallet_step_readonly_label: {
    id: 'shipwallet_step_readonly_label',
    defaultMessage: 'Shipping'
  },
  payment_step_title: {
    id: 'payment_step_title',
    defaultMessage: 'Payment method'
  },
  payment_step_message: {
    id: 'payment_step_message',
    defaultMessage: 'All transactions are secure and encrypted'
  },
  payment_group_title: {
    id: 'payment_group_title',
    defaultMessage: 'Payment options'
  },
  payment_handling_cost_label: {
    id: 'payment_handling_cost_label',
    defaultMessage: 'Handling cost: {handlingCost}'
  },
  address_step_title: {
    id: 'address_step_title',
    defaultMessage: 'Customer information'
  },
  ingrid_fields_step_title: {
    id: 'ingrid_fields_step_title',
    defaultMessage: 'Delivery options'
  },
  // Cart
  information_header_label: {
    id: 'information_header_label',
    defaultMessage: 'Checkout information'
  },
  information_button_label: {
    id: 'information_button_label',
    defaultMessage: 'OK, I got it'
  },
  shop_more_button_label: {
    id: 'shop_more_button_label',
    defaultMessage: 'Shop more'
  },
  cart_label: {
    id: 'cart_label',
    defaultMessage: 'Your cart'
  },
  checkout_button_label: {
    id: 'checkout_button_label',
    defaultMessage: 'Go to checkout'
  },
  close_cart_button_label: {
    id: 'close_cart_button_label',
    defaultMessage: 'Close'
  },
  cart_separator_text: {
    id: 'cart_separator_text',
    defaultMessage: 'or'
  },
  cart_wallet_klarna_checkout_label: {
    id: 'cart_wallet_klarna_checkout_label',
    defaultMessage: 'Pay with Klarna'
  },
  // Voucher
  voucher_group_label: {
    id: 'voucher_group_label',
    defaultMessage: 'Voucher'
  },
  voucher_switch_button_label: {
    id: 'voucher_switch_button_label',
    defaultMessage: 'Add voucher'
  },
  voucher_apply_button_label: {
    id: 'voucher_apply_button_label',
    defaultMessage: 'Apply'
  },
  voucher_remove_button_label: {
    id: 'voucher_remove_button_label',
    defaultMessage: 'Remove'
  },
  voucher_input_label: {
    id: 'voucher_input_label',
    defaultMessage: 'Gift card or discount code'
  },
  voucher_input_placeholder: {
    id: 'voucher_input_placeholder',
    defaultMessage: 'Gift card or discount code'
  },
  // Fetch Perssonall Identity Number
  pin_fetch_button_label: {
    id: 'pin_fetch_button_label',
    defaultMessage: 'Fetch',
  },
  pin_input_label: {
    id: 'pin_input_label',
    defaultMessage: 'Personal identity number',
  },
  pin_input_placeholder: {
    id: 'pin_input_placeholder',
    defaultMessage: 'Personal identity number',
  },
  pin_not_found_error_message: {
    id: 'pin_not_found_error_message',
    defaultMessage: 'Personal identity number not found',
  },
  // Order
  show_more_products_button_label: {
    id: 'show_more_products_button_label',
    defaultMessage: 'See all {itemsLength} products'
  },
  show_less_products_button_label: {
    id: 'show_less_products_button_label',
    defaultMessage: 'Hide products',
  },
  total_price_message: {
    id: 'total_price_message',
    defaultMessage: '{grandTotalPrice} in total'
  },
  order_summary_label: {
    id: 'order_summary_label',
    defaultMessage: 'Order summary'
  },
  open_order_label: {
    id: 'open_order_label',
    defaultMessage: 'Order ({grandTotalPrice})'
  },
  close_order_label: {
    id: 'close_order_label',
    defaultMessage: 'See checkout'
  },
  // Gift wrap
  gift_wrap_switch_button_label: {
    id: 'gift_wrap_switch_button_label',
    defaultMessage: 'Gift wrap'
  },
  // Autocomplete
  current_location_denited_label: {
    id: 'current_location_denited_label',
    defaultMessage: 'Access to your location is blocked by your browser settings',
  },
  current_location_label: {
    id: 'current_location_label',
    defaultMessage: 'Use current location',
  },
  fetching_current_location_label: {
    id: 'fetching_current_location_label',
    defaultMessage: 'Fetching address...',
  },
  // Address fields
  country_label: {
    id: 'country_label',
    defaultMessage: 'Country'
  },
  country_dropdown_placeholder: {
    id: 'country_dropdown_placeholder',
    defaultMessage: 'Choose country...'
  },
  state_label: {
    id: 'state_label',
    defaultMessage: 'State'
  },
  state_dropdown_placeholder: {
    id: 'state_dropdown_placeholder',
    defaultMessage: 'Choose state...'
  },
  personal_number_label: {
    id: 'personal_number_label',
    defaultMessage: 'Personal identity number'
  },
  personal_number_placeholder: {
    id: 'personal_number_placeholder',
    defaultMessage: 'Personal identity number'
  },
  first_name_label: {
    id: 'first_name_label',
    defaultMessage: 'First Name'
  },
  first_name_placeholder: {
    id: 'first_name_placeholder',
    defaultMessage: 'First Name'
  },
  last_name_label: {
    id: 'last_name_label',
    defaultMessage: 'Last Name'
  },
  company_placeholder: {
    id: 'company_placeholder',
    defaultMessage: 'Company (optional)'
  },
  company_label: {
    id: 'company_label',
    defaultMessage: 'Company'
  },
  last_name_placeholder: {
    id: 'last_name_placeholder',
    defaultMessage: 'Last Name'
  },
  email_label: {
    id: 'email_label',
    defaultMessage: 'Email'
  },
  email_placeholder: {
    id: 'email_placeholder',
    defaultMessage: 'Email'
  },
  phone_number_label: {
    id: 'phone_number_label',
    defaultMessage: 'Phone number'
  },
  phone_number_placeholder: {
    id: 'phone_number_placeholder',
    defaultMessage: 'Phone number'
  },
  address_1_label: {
    id: 'address_1_label',
    defaultMessage: 'Address'
  },
  address_1_placeholder: {
    id: 'address_1_placeholder',
    defaultMessage: 'Address'
  },
  address_2_label: {
    id: 'address_2_label',
    defaultMessage: 'Address 2'
  },
  address_2_placeholder: {
    id: 'address_2_placeholder',
    defaultMessage: 'Address 2'
  },
  houseNumber_placeholder: {
    id: 'houseNumber_placeholder',
    defaultMessage: 'Door code, etc.'
  },
  houseNumber_label: {
    id: 'houseNumber_label',
    defaultMessage: 'Door code, etc.'
  },
  zip_code_label: {
    id: 'zip_code_label',
    defaultMessage: 'Zip code'
  },
  zip_code_placeholderl: {
    id: 'zip_code_placeholder',
    defaultMessage: 'Zip code'
  },
  city_label: {
    id: 'city_label',
    defaultMessage: 'City'
  },
  city_placeholder: {
    id: 'city_placeholder',
    defaultMessage: 'City'
  },
  ship_to_different_label: {
    id: 'ship_to_different_label',
    defaultMessage: 'Ship items to another address'
  },
  remember_me_label: {
    id: 'remember_me_label',
    defaultMessage: 'Save my information for a faster checkout'
  },
  consent_group_title: {
    id: 'consent_group_title',
    defaultMessage: 'Consents'
  },
  terms_and_conditions_label: {
    id: 'terms_and_conditions_label',
    defaultMessage: 'I agree to'
  },
  terms_and_conditions_link_label: {
    id: 'terms_and_conditions_link_label',
    defaultMessage: 'terms & conditions'
  },
  newsletter_checkbox_label: {
    id: 'newsletter_checkbox_label',
    defaultMessage: 'I\'d like to receive the newsletter'
  },
  newsletter_checkbox_link_label: {
    id: 'newsletter_checkbox_link_label',
    defaultMessage: 'Terms & Conditions'
  },
  shipping_label: {
    id: 'shipping_label',
    defaultMessage: 'Shipping options'
  },
  // Summary
  subtotal_label: {
    id: 'subtotal_label',
    defaultMessage: 'Subtotal'
  },
  shipping_sumary_label: {
    id: 'shipping_sumary_label',
    defaultMessage: 'Shipping'
  },
  payment_handling_label: {
    id: 'payment_handling_label',
    defaultMessage: 'Payment handling cost'
  },
  newsletter_label: {
    id: 'newsletter_label',
    defaultMessage: 'Newsletter'
  },
  total_label: {
    id: 'total_label',
    defaultMessage: 'Total'
  },
  including_tax_label: {
    id: 'including_tax_label',
    defaultMessage: 'Including {taxPercent}% tax'
  },
  tax_deducted_label: {
    id: 'tax_deducted_label',
    defaultMessage: 'Tax deducted',
  },
  discount_label: {
    id: 'discount_label',
    defaultMessage: 'Discount'
  },
  // Receipt
  order_details_label: {
    id: 'order_details_label',
    defaultMessage: 'Order details'
  },
  order_number_label: {
    id: 'order_number_label',
    defaultMessage: 'Order number:'
  },
  order_date_label: {
    id: 'order_date_label',
    defaultMessage: 'Order date:'
  },
  order_status_label: {
    id: 'order_status_label',
    defaultMessage: 'Order status:'
  },
  payment_method_receipt_title: {
    id: 'payment_method_receipt_title',
    defaultMessage: 'Payment method:'
  },
  delivery_method_receipt_title: {
    id: 'delivery_method_receipt_title',
    defaultMessage: 'Delivery method:'
  },
  shipping_address_receipt_title: {
    id: 'shipping_address_receipt_title',
    defaultMessage: 'Shipping address'
  },
  bought_items_label: {
    id: 'bought_items_label',
    defaultMessage: 'Items you bought'
  },
  order_summary_receipt_title: {
    id: 'order_summary_receipt_title',
    defaultMessage: 'Order summary'
  },
  print_receipt_label: {
    id: 'print_receipt_label',
    defaultMessage: 'Print receipt'
  },
  thank_message: {
    id: 'thank_message',
    defaultMessage: 'Thank you for your order!'
  },
  additional_notes_label: {
    id: 'additional_notes_label',
    defaultMessage: 'Add your order notes here'
  },
  additional_notes_placeholder: {
    id: 'additional_notes_placeholder',
    defaultMessage: 'Add your order notes here'
  },
  place_order_button_label: {
    id: 'place_order_button_label',
    defaultMessage: 'Place order'
  },
  place_order_button_paypal_label: {
    id: 'place_order_button_paypal_label',
    defaultMessage: 'Pay with PayPal'
  },
  contact_group_title: {
    id: 'contact_group_title',
    defaultMessage: 'Contact details'
  },
  customer_information_group_title: {
    id: 'customer_information_group_title',
    defaultMessage: 'Customer information'
  },
  shipping_country_group_title: {
    id: 'shipping_country_group_title',
    defaultMessage: 'Shipping country'
  },
  shipping_address_group_title: {
    id: 'shipping_address_group_title',
    defaultMessage: 'Shipping address'
  },
  billing_address_group_title: {
    id: 'billing_address_group_title',
    defaultMessage: 'Billing address'
  },
  order_message_group_title: {
    id: 'order_message_group_title',
    defaultMessage: 'Leave a message with your order'
  },
  billing_address_checkbox_label: {
    id: 'billing_address_checkbox_label',
    defaultMessage: 'Same as shipping address'
  },
  billing_address_receipt_title: {
    id: 'billing_address_receipt_title',
    defaultMessage: 'Billing address'
  },
  continue_shopping_receipt_link_label: {
    id: 'continue_shopping_receipt_link_label',
    defaultMessage: 'Continue shopping'
  },
  // Membership
  membership_no_orders_message: {
    id: 'membership_no_orders_message',
    defaultMessage: 'You have not placed orders yet'
  },
  membership_no_checks_message: {
    id: 'membership_no_checks_message',
    defaultMessage: 'You have no checks available yet',
  },
  membership_available_checks: {
    id: 'membership_available_checks',
    defaultMessage: 'Available checks'
  },
  membership_used_checks: {
    id: 'membership_used_checks',
    defaultMessage: 'Used checks'
  },
  membership_register_error_email: {
    id: 'membership_register_error_email',
    defaultMessage: 'Email address already in use'
  },
  customer_not_fount: {
    id: 'customer_not_fount',
    defaultMessage: 'We weren\'t able to identify you for the given address email provided'
  },
  membership_register_error_other: {
    id: 'membership_register_error_other',
    defaultMessage: 'Something went wrong'
  },
  membership_login_error_password: {
    id: 'membership_login_error_password',
    defaultMessage: 'Password is incorrect'
  },
  membership_password_reset_link_expire_error: {
    id: 'membership_password_reset_link_expire_error',
    defaultMessage: 'Your password reset link has expired, you can initiate another password reset request'
  },
  membership_tabs_personal: {
    id: 'membership_tabs_personal',
    defaultMessage: 'Account details'
  },
  membership_tabs_checks: {
    id: 'membership_tabs_checks',
    defaultMessage: 'Checks'
  },
  membership_tabs_password: {
    id: 'membership_tabs_password',
    defaultMessage: 'Change password'
  },
  membership_tabs_orders: {
    id: 'membership_tabs_orders',
    defaultMessage: 'Order history'
  },
  membership_personal_data_title: {
    id: 'membership_personal_data_title',
    defaultMessage: 'Personal data',
  },
  membership_personal_data_subtitle: {
    id: 'membership_personal_data_subtitle',
    defaultMessage: 'Here\'s your personal and shipping data',
  },
  membership_change_password_title: {
    id: 'membership_change_password_title',
    defaultMessage: 'Password settings',
  },
  membership_change_password_subtitle: {
    id: 'membership_change_password_subtitle',
    defaultMessage: 'To change your password, you\'ll have to provide your current one',
  },
  membership_forgot_password_title: {
    id: 'membership_forgot_password_title',
    defaultMessage: 'Set up your new password',
  },
  membership_forgot_password_subtitle: {
    id: 'membership_forgot_password_subtitle',
    defaultMessage: 'It\'s easy!',
  },
  membership_recovery_password_title: {
    id: 'membership_recovery_password_title',
    defaultMessage: 'Password recovery',
  },
  membership_recovery_password_subtitle: {
    id: 'membership_recovery_password_subtitle',
    defaultMessage: 'Please provide e-mail, we will send you a link to change your password',
  },
  membership_login_title: {
    id: 'membership_login_title',
    defaultMessage: 'Log in',
  },
  membership_login_subtitle: {
    id: 'membership_login_subtitle',
    defaultMessage: 'We\'re glad you\'re back',
  },
  membership_orders_history_title: {
    id: 'membership_orders_history_title',
    defaultMessage: 'Your previous orders',
  },
  membership_orders_history_subtitle: {
    id: 'membership_orders_history_subtitle',
    defaultMessage: 'Here\'s the list of your orders',
  },
  membership_checks_subtitle: {
    id: 'membership_checks_subtitle',
    defaultMessage: 'Here\'s the list of available vouchers that you can use in the checkout page',
  },
  membership_check_voucher_code_label: {
    id: 'membership_check_voucher_code_label',
    defaultMessage: 'Voucher code:',
  },
  membership_check_discount_label: {
    id: 'membership_check_discount_label',
    defaultMessage: 'Discount:',
  },
  membership_check_data_valid_label: {
    id: 'membership_check_data_valid_label',
    defaultMessage: 'Expires:',
  },
  membership_check_data_used_label: {
    id: 'membership_check_data_used_label',
    defaultMessage: 'Used:',
  },
  membership_points_balance_label: {
    id: 'membership_points_balance_label',
    defaultMessage: 'Points balance for bonus:',
  },
  membership_firstname_placeholder: {
    id: 'membership_firstname_placeholder',
    defaultMessage: 'Name',
  },
  membership_firstname_label: {
    id: 'membership_firstname_label',
    defaultMessage: 'Name',
  },
  membership_lastname_placeholder: {
    id: 'membership_lastname_placeholder',
    defaultMessage: 'Surname',
  },
  membership_lastname_label: {
    id: 'membership_lastname_label',
    defaultMessage: 'Surname',
  },
  membership_address1_placeholder: {
    id: 'membership_address1_placeholder',
    defaultMessage: 'Address 1',
  },
  membership_address1_label: {
    id: 'membership_address1_label',
    defaultMessage: 'Address 1',
  },
  membership_address2_placeholder: {
    id: 'membership_address2_placeholder',
    defaultMessage: 'Address 2',
  },
  membership_address2_label: {
    id: 'membership_address2_label',
    defaultMessage: 'Address 2',
  },
  membership_country_placeholder: {
    id: 'membership_country_placeholder',
    defaultMessage: 'Choose country...',
  },
  membership_country_label: {
    id: 'membership_country_label',
    defaultMessage: 'Country',
  },
  membership_city_placeholder: {
    id: 'membership_city_placeholder',
    defaultMessage: 'City',
  },
  membership_city_label: {
    id: 'membership_city_label',
    defaultMessage: 'City',
  },
  membership_state_placeholder: {
    id: 'membership_state_placeholder',
    defaultMessage: 'Choose state...',
  },
  membership_state_label: {
    id: 'membership_state_label',
    defaultMessage: 'State',
  },
  membership_zipcode_placeholder: {
    id: 'membership_zipcode_placeholder',
    defaultMessage: 'Zip code',
  },
  membership_zipcode_label: {
    id: 'membership_zipcode_label',
    defaultMessage: 'Zip code',
  },
  membership_email_placeholder: {
    id: 'membership_email_placeholder',
    defaultMessage: 'E-mail',
  },
  membership_email_label: {
    id: 'membership_email_label',
    defaultMessage: 'E-mail',
  },
  membership_phone_placeholder: {
    id: 'membership_phone_placeholder',
    defaultMessage: 'Phone number',
  },
  membership_phone_label: {
    id: 'membership_phone_label',
    defaultMessage: 'Phone number',
  },
  membership_password_placeholder: {
    id: 'membership_password_placeholder',
    defaultMessage: 'Password',
  },
  membership_password_label: {
    id: 'membership_password_label',
    defaultMessage: 'Password',
  },
  membership_current_password_placeholder: {
    id: 'membership_current_password_placeholder',
    defaultMessage: 'Current password',
  },
  membership_current_password_label: {
    id: 'membership_current_password_label',
    defaultMessage: 'Current password',
  },
  membership_show_password_tooltip: {
    id: 'membership_show_password_tooltip',
    defaultMessage: 'Show password',
  },
  membership_password_confirm_placeholder: {
    id: 'membership_password_confirm_placeholder',
    defaultMessage: 'Re-enter password',
  },
  membership_password_confirm_label: {
    id: 'membership_password_confirm_label',
    defaultMessage: 'Re-enter password',
  },
  membership_new_password_placeholder: {
    id: 'membership_new_password_placeholder',
    defaultMessage: 'New password',
  },
  membership_new_password_label: {
    id: 'membership_new_password_label',
    defaultMessage: 'New password',
  },
  membership_new_password_save: {
    id: 'membership_new_password_save',
    defaultMessage: 'Save new password',
  },
  membership_password_recovery: {
    id: 'membership_password_recovery',
    defaultMessage: 'Start recovery',
  },
  membership_identity_number_placeholder: {
    id: 'membership_identity_number_placeholder',
    defaultMessage: 'Personal Identity Number',
  },
  membership_identity_number_label: {
    id: 'membership_identity_number_label',
    defaultMessage: 'Personal Identity Number',
  },
  membership_physical_store_placeholder: {
    id: 'membership_physical_store_placeholder',
    defaultMessage: 'Select store...',
  },
  membership_physical_store_label: {
    id: 'membership_physical_store_label',
    defaultMessage: 'Store',
  },
  membership_register_continue_button_label: {
    id: 'membership_register_continue_button_label',
    defaultMessage: 'Continue',
  },
  membership_save: {
    id: 'membership_save',
    defaultMessage: 'Save',
  },
  membership_update: {
    id: 'membership_update',
    defaultMessage: 'Update',
  },
  membership_login_button_label: {
    id: 'membership_login_button_label',
    defaultMessage: 'Log in',
  },
  membership_back_to_login: {
    id: 'membership_back_to_login',
    defaultMessage: 'Back to login',
  },
  membership_logout: {
    id: 'membership_logout',
    defaultMessage: 'Logout',
  },
  membership_forgotten_password: {
    id: 'membership_forgotten_password',
    defaultMessage: 'Forgot your password?',
  },
  membership_not_your_account: {
    id: 'membership_not_your_account',
    defaultMessage: 'Not your account? ',
  },
  membership_continue_as_guest: {
    id: 'membership_continue_as_guest',
    defaultMessage: 'Continue as a guest or ',
  },
  membership_continue: {
    id: 'membership_continue',
    defaultMessage: 'Continue',
  },
  membership_start: {
    id: 'membership_start',
    defaultMessage: 'Start',
  },
  membership_greeting: {
    id: 'membership_greeting',
    defaultMessage: 'Hello',
  },
  membership_close_overlay: {
    id: 'membership_close_overlay',
    defaultMessage: 'Close',
  },
  membership_show_more: {
    id: 'membership_show_more',
    defaultMessage: 'Show older entries',
  },
  membership_order_status: {
    id: 'membership_order_status',
    defaultMessage: 'Status',
  },
  membership_order_delivery: {
    id: 'membership_order_delivery',
    defaultMessage: 'Delivery',
  },
  membership_order_summary_title: {
    id: 'membership_order_summary_title',
    defaultMessage: 'Order summary',
  },
  membership_account_subtitle: {
    id: 'membership_account_subtitle',
    defaultMessage: 'Here you can manage your account',
  },
  notifications_recovery_success: {
    id: 'notifications_recovery_success',
    defaultMessage: 'An email has been sent with further instructions',
  },
  notifications_change_success: {
    id: 'notifications_change_success',
    defaultMessage: 'Your password has been successfully updated',
  },
  notifications_update_success: {
    id: 'notifications_update_success',
    defaultMessage: 'Personal data has been successfully updated',
  },
  membership_gender_female: {
    id: 'membership_gender_female',
    defaultMessage: 'Female',
  },
  membership_gender_male: {
    id: 'membership_gender_male',
    defaultMessage: 'Male',
  },
  membership_personal_information_group_title: {
    id: 'membership_personal_information_group_title',
    defaultMessage: 'Personal information',
  },
  membership_gender_label: {
    id: 'membership_gender_label',
    defaultMessage: 'Gender',
  },
  membership_gender_placeholder: {
    id: 'membership_gender_placeholder',
    defaultMessage: 'Choose gender...',
  },
  membership_dob_label: {
    id: 'membership_dob_label',
    defaultMessage: 'Date of birth',
  },
  membership_dob_placeholder: {
    id: 'membership_dob_placeholder',
    defaultMessage: 'Date of birth',
  },
});

export default messages;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/i18n/base-en.ts